/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ACCOUNT_TYPE = "STUDENT" | "TEACHER" | "%future added value";
export type CLASSROOM_MEMBERSHIP_LEVEL = "ADMIN" | "BANNED" | "CREATOR" | "MEMBER" | "PENDING" | "%future added value";
export type DashboardLayout_viewer = {
    readonly user: {
        readonly id: string;
        readonly isAdmin: boolean;
        readonly accountType: ACCOUNT_TYPE | null;
        readonly isUpgradedTeacher: boolean;
        readonly classroomMemberships: ReadonlyArray<{
            readonly level: CLASSROOM_MEMBERSHIP_LEVEL;
            readonly classroom: {
                readonly id: string;
                readonly title: string;
                readonly identifier: string;
            };
        } | null>;
    } | null;
    readonly " $refType": "DashboardLayout_viewer";
};
export type DashboardLayout_viewer$data = DashboardLayout_viewer;
export type DashboardLayout_viewer$key = {
    readonly " $data"?: DashboardLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DashboardLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isAdmin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isUpgradedTeacher",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "classroomMemberships",
          "storageKey": null,
          "args": null,
          "concreteType": "ClassroomMembership",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "level",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "classroom",
              "storageKey": null,
              "args": null,
              "concreteType": "Classroom",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "identifier",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '632d49942f6e21a723c735d767e1a972';
export default node;
